import { useCallback, useState } from "react";

export interface DialogController<T> {
  data?: T;
  handleClose: () => void;
  handleOpen: (data?: T) => void;
  setOpen: (open: boolean) => void;
  open: boolean;
}

export function useDialog<T = unknown>(initalOpen = false, initalData?: T): DialogController<T> {
  const [state, setState] = useState<{ open: boolean; data?: T }>({
    open: initalOpen,
    data: initalData,
  });

  const handleOpen = useCallback((data?: T): void => {
    setState({ open: true, data });
  }, []);

  const handleClose = useCallback((): void => {
    setState({ open: false });
  }, []);

  const setOpen = useCallback((open: boolean): void => {
    setState((prevState) => ({ ...prevState, open }));
  }, []);

  return {
    data: state.data,
    handleClose,
    handleOpen,
    setOpen,
    open: state.open,
  };
}
